import { render } from "./Pwa_Install_Prompt.vue?vue&type=template&id=34107255&scoped=true"
import script from "./Pwa_Install_Prompt.vue?vue&type=script&lang=js"
export * from "./Pwa_Install_Prompt.vue?vue&type=script&lang=js"

import "./Pwa_Install_Prompt.vue?vue&type=style&index=0&id=34107255&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34107255"]])

export default __exports__